<div class="geral">
  <div class="beneficios__container">
    <!-- <div class="subtitulo">
      <p class="subtitulo__texto">
        Confira todos os Benefícios Lovers disponíveis para você!
      </p>
    </div> -->

    <div class="campo__pesquisa">
      <button class="botao__filtrar" (click)="this.exibirPopupFiltro = true" [ngClass]="{ active: buttonFiltrar }">
        <img class="icone__filtro" src="assets/images/icons/filter.png" />
        <span class="lbl_filtrar">Filtrar</span>
      </button>

      <div class="input__pesquisa">
        <form (ngSubmit)="aplicarFiltros()" [formGroup]="pesquisaForm">
          <input class="pesquisar" type="text" placeholder="Buscar momento especial"
            formControlName="textoPesquisa" /><img class="icone__pesquisa" src="assets/images/icons/search_regular.png"
            (click)="aplicarFiltros()" *ngIf="!loadingAplicar" />
          <i *ngIf="loadingAplicar" class="fa fa-spinner fa-spin loading--input"></i>
        </form>
      </div>
    </div>
    <div class="div__filtros_selecionados" *ngIf="buttonFiltrar">
      <p *ngFor="let item of obterFiltrosSelecionados(this.niveisLista)">
        <span *ngIf="item">
          {{ item.nome }}
          <strong (click)="desmarcarItem(item)">X</strong>
        </span>
      </p>
      <p *ngFor="let item of obterFiltrosSelecionados(this.categoriasLista)">
        <span *ngIf="item">
          {{ item.descricao }}
          <strong (click)="desmarcarItem(item)">X</strong>
        </span>
      </p>
    </div>

    <ngx-skeleton-loader class="detalhes__experiencia--loader" *ngIf="carregandoBeneficios" count="6" [theme]="{
        'border-radius': '25px',
        width: '100%',
        height: '197px',
        margin: '40px 0 10px 0'
      }"></ngx-skeleton-loader>

    <ngx-skeleton-loader class="detalhes__experiencia loader--mobile" *ngIf="carregandoBeneficios" count="6" [theme]="{
        'border-radius': '25px',
        width: '100%',
        height: '300px',
        margin: '0 0 10px 0'
      }"></ngx-skeleton-loader>

    <p class="quantidade__cards" *ngIf="countBeneficios != null">
      {{ countBeneficios }} benefícios
    </p>

    <div class="cards__container">
      <div class="card" *ngFor="let item of this.beneficios; let i = index" (click)="abrirPopup(item)"
        [ngClass]="{ 'card--destaque': item.destaque }">
        <div class="nova__categoria" *ngIf="item.tag">
          <p class="categoria__texto">{{ item.tag }}</p>
        </div>
        <img class="card__imagem" src="{{ item.imagemSrc }}" />
        <div class="card__conteudo">
          <div class="conteudo__texto">
            <p class="conteudo__titulo">{{ item.nome }}</p>
            <p class="conteudo__detalhes">
              {{ item.descricao }}
            </p>
          </div>
          <div class="card__niveis">
            <div class="tag" *ngFor="let nivel of item.experienciaNiveis" [ngClass]="{
                'nivel--paquera': nivel.idNivel == 6,
                'nivel--paixao': nivel.idNivel == 7,
                'nivel--amor': nivel.idNivel == 8,
                'nivel--mozao': nivel.idNivel == 9,
                'nivel--embaixador': nivel.idNivel == 10,
                'nivel--mozao-desabilitado': nivelMembro != 9,
                'nivel--embaixador-desabilitado': nivelMembro != 10
              }">
              <p class="nivel__descricao font__tag">
                {{ nivel.descricaoNivel | lowercase }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sem__momentos__especiais" *ngIf="countBeneficios == 0">
      <div class="card__sem__momentos">
        <img src="assets/images/icons/search_not_found.png" alt="" />
      </div>
      <div class="titulo__sem__momentos">
        <p>Nenhum benefício encontrado</p>
      </div>
      <div class="texto__sem__momentos">
        <p>O filtro selecionado não retornou benefícios existentes.</p>
      </div>
    </div>

    <div class="acordeon">
      <lovers-accordion class="lovers__accordion" titulo="Regras Gerais de Uso do Benefício"
        [tamanhoTitulo]="tituloAcordeon">
        <p class="regras__gerais" *ngIf="this.regrasGerais">
          {{ this.regrasGerais }}
        </p>
      </lovers-accordion>
    </div>
  </div>
</div>

<!-- pop-ups -->
<lovers-popup [exibir]="exibirPopup" (onClose)="fecharPopup()" tamanho="pequeno">
  <!--skeleton-->
  <ngx-skeleton-loader *ngIf="carregandoBeneficioDetalhe" count="1" [theme]="{ 'border-radius': '10px', width: '30%' }">
  </ngx-skeleton-loader>
  <ngx-skeleton-loader *ngIf="carregandoBeneficioDetalhe" count="4"
    [theme]="{ 'border-radius': '30px', width: '100%' }"></ngx-skeleton-loader>

  <div class="popup__geral" *ngIf="this.beneficio">
    <div class="popup__header">
      <p class="header__title">{{ beneficio.nome }}</p>
      <p class="header__descricao">{{ beneficio.descricao }}</p>
    </div>

    <div class="popup__body">
      <div class="container__disabled__message" *ngIf="!membroPertenceAoNivel(beneficio.experienciaNiveis)">
        <app-dynamic-disable-message [tipoDisable]="messageDisabled"></app-dynamic-disable-message>
      </div>
      <div class="codigo" *ngIf="membroPertenceAoNivel(beneficio.experienciaNiveis)">
        <div class="codigo__pontilhado" *ngIf="this.cupom !== null && this.cupom !== ''">
          <p class="codigo__texto">{{ this.cupom }}</p>
        </div>
        <div class="codigo__botao" *ngIf="this.linkExterno != '' && this.linkExterno != null">
          <button class="btn_default" (click)="abrirLinkExterno(this.linkExterno)">
            Ir para o Site &nbsp;
            <svg class="icone__entenda" width="10" height="13" viewBox="0 0 10 17" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M2 15.1016L8 8.76956L2 2.4375" stroke="#fff" stroke-width="3" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <div class="codigo__botao" *ngIf="beneficio.idPromocao > 0">
          <button *ngIf="!btnBeneficioDisponivel" (click)="validarCondicaoResgate()" class="btn_default"
            [ngClass]="{ 'lovers--disabled': carregandoResgate }">
            <img class="img__btn" src="assets/images/icons/gift_white_closed.png" />
            Ativar Benefício
            <i *ngIf="carregandoResgate" class="fa fa-spinner fa-spin"></i>
          </button>
          <button *ngIf="btnBeneficioDisponivel" routerLink="/minhas-experiencias" class="btn-disponivel">
            <img class="img__btn" src="assets/images/icons/gift_green_open.png" />
            Benefício disponível
            <svg class="icone__entenda" width="10" height="19" viewBox="0 0 10 17" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M2 15.1016L8 8.76956L2 2.4375" stroke="#23AB61" stroke-width="3" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
      <div class="localizacao" (click)="abrirModalLocalizacao(beneficio.id)">
        <img src="assets/images/icons/location-simbol.png" />
        <p class="lbl_locais_disponiveis">Veja os locais disponíveis</p>
        <img src="assets/images/icons/avancar-pequeno.png" />
      </div>
      <div class="acordeon" *ngIf="beneficio.promocao">
        <lovers-accordion class="lovers__accordion" image="assets/images/icons/cesta.png"
          titulo="Produtos participantes" tamanhoTitulo="Produtos participantes">
          <div class="itens">
            <div *ngFor="let item of beneficio.promocao.promotionItens">
              <p>{{ item.descricaoProduto }}</p>
            </div>
          </div>
        </lovers-accordion>
      </div>
      <p class="lbl_texto_cupom">{{ this.textoCupom }}</p>
    </div>

    <div class="popup__footer">
      <p class="footer__texto">{{ beneficio.textoLegal }}</p>
    </div>
  </div>
  <app-localizacao [exibirModal]="modalLocalizacao" (fecharCardLocalizacao)="abrirPopupLocaisDisponiveis(false)"
    [idExperiencia]="idBeneficio">
  </app-localizacao>
</lovers-popup>

<lovers-popup *ngIf="showPopupMsgGenerica" (onClose)="showPopupMsgGenerica = false" [exibir]="true" tamanho="pequeno">
  <div class="popup__geral">
    <div class="popup__header">
      <p class="header__title">{{ tituloModal }}</p>
      <p class="header__descricao">{{ textoModal }}</p>
    </div>
  </div>
</lovers-popup>

<lovers-popup (onClose)="exibirPopupFiltro = false" [exibir]="exibirPopupFiltro" tamanho="pequeno">
  <div class="geral__filtro">
    <div class="titulo__filtro">
      <p>Filtrar</p>
    </div>

    <div class="campos__filtragem">
      <div class="campo">
        <p class="titulo__campo">
          <img class="titulo__icone" src="assets/images/icons/heart.png" />Niveis
        </p>

        <div class="niveis">
          <div class="nivel__opcao" *ngFor="let nivel of niveisLista; let i = index" (click)="selecionarNivel(i)"
            [ngClass]="{
              'nivel--selecionado': nivel.selecionado,
              'nivel--crush': nivel.id == 5,
              'nivel--paquera': nivel.id == 6,
              'nivel--paixao': nivel.id == 7,
              'nivel--amor': nivel.id == 8
            }">
            <span class="lovers-font--leahlee">{{
              nivel.nome | lowercase
              }}</span>
          </div>
        </div>

        <div class="campo">
          <p class="titulo__campo">
            <img class="titulo__icone" src="assets/images/icons/claquete-escuro.png" />Categorias
          </p>
          <div class="lista">
            <div class="campo" *ngFor="let categoria of categoriasLista; let i = index" (click)="selecionarCategoria(i)"
              [ngClass]="{ selecionado: categoria.selecionado }">
              <span>{{ categoria.descricao }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="popup__footer popup__filtro">
    <button class="button__limpar__filtro" (click)="limparFiltros()">
      Limpar filtros
    </button>
    <button [ngClass]="{ disable: loadingAplicar == true }" class="button__aplicar__filtro" (click)="aplicarFiltros()">
      Aplicar &nbsp;
      <i *ngIf="loadingAplicar" class="fa fa-spinner fa-spin"></i>
    </button>
  </div>
</lovers-popup>